/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import BetForm from '../sub_components/betForm'
import * as stringParser from '../../util/string.util'
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../../configs/const';
let oid = OPERATOR_ID.toLowerCase()
export default class InPlayEventBinary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            runner_name: "",
            bid_at: 0,
            bid_line: 0,
            bid_for: "back",
            market: {},
            teams: [],
            eventMarket: {},
            marketId: ""
        };
    }
    componentWillUnmount() {
        if(!!this.props.socket){
            this.props.socket.off("market_room")
        }
    }
    componentDidMount() {
        const socket = this.props.socket;
        let eventMarket = !!this.props.event.markets && this.props.event.markets.length > 0 ? this.props.event.markets.filter((mkt, k) => {
            return mkt.marketType === "MATCH_ODDS"
        }) : []
        eventMarket = eventMarket.length > 0 ? eventMarket[0] : !!this.props.event.markets ? this.props.event.markets[0] : null
        if (!!eventMarket && !!eventMarket.marketBook) {
            let market = !!this.props.feedBooks[eventMarket.marketId] ? this.props.feedBooks[eventMarket.marketId] : eventMarket.marketBook
            // market.evtMeta = eventMarket.metadata.eventMeta
            this.setState({ market: market, teams: eventMarket.runners })
        }
        let stream = ""

        this.setState({ marketId: eventMarket.marketId })
        const accData = JSON.parse(localStorage.getItem("accountData"));
        if(!!accData && Object.keys(accData).length > 0) {
            if (this.props.subscribedMarkets.indexOf(eventMarket.marketId) === -1) {
                if (this.props.subscriptions.market_room.indexOf(eventMarket.marketId) === -1) {
                    this.props.subscribe('market_room', eventMarket.marketId)
                    socket.emit('market_room', eventMarket.marketId)
                    this.props.updateSubscribedMarkets(eventMarket.marketId)
                }
            }
            socket.on("market_room", data => {
                if (stream !== data) {
                    stream = data
                    let newBook = stringParser.deSrlz(data)
                    // newBook.evtMeta = eventMarket.metadata.eventMeta
                    if (eventMarket.marketId === newBook.marketId) {
                        this.props.updateBook(eventMarket.marketId, newBook)
                        let curBook = this.state.market
                        curBook.runners.forEach((rn, i) => {
                            let nrn = newBook.runners[i]
                            rn.back.forEach((bk, j) => {
                                if (!!nrn.back[j]) {
                                    if (bk.line !== nrn.back[j].line) {
                                        nrn.back[j].has_blink = true
                                    } else {
                                        nrn.back[j].has_blink = false
                                    }
                                }
                            })
                            rn.lay.forEach((ly, k) => {
                                if (!!nrn.lay[k]) {
                                    if (ly.line !== nrn.lay[k].line) {
                                        nrn.lay[k].has_blink = true
                                    } else {
                                        nrn.lay[k].has_blink = false
                                    }
                                }
                            })
                            newBook.runners[i] = nrn
                        });
                        this.setState({ market: newBook }, () => {
                            setTimeout(() => {
                                curBook.runners.forEach((rn, i) => {
                                    let nrn = newBook.runners[i]
                                    rn.back.forEach((bk, j) => {
                                        if (!!nrn.back[j]) {
                                            nrn.back[j].has_blink = false
                                        }
                                    })
                                    rn.lay.forEach((ly, k) => {
                                        if (!!nrn.lay[k]) {
                                            nrn.lay[k].has_blink = false
                                        }
                                    })
                                    newBook.runners[i] = nrn
                                });
                                this.setState({ market: newBook })
                            }, 500)
                        })
                    }
                }
            });
            socket.on('disconnect', () => {
                socket.emit('market_room', eventMarket.marketId)
            })
        }
    }
    // selectBid(runner_name, bid_at, bid_line, game_code, bid_for, event_index, team) {
    //     localStorage.setItem("betForm", JSON.stringify({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, bid_for: bid_for, selectionId: team.id }))
    //     this.setState({ runner_name: runner_name, bid_at: bid_at, bid_line: bid_line, bid_amount: 0, bid_for: bid_for, selectionId: team.id }, () => {
    //         this.props.betForm(game_code, event_index, "clicked")
    //     })
    // }
    // selectBid(market.catalogue.marketName, runner_bk.lay[0].price, market.catalogue.marketId, "lay", market.catalogue.runners[0], runner_bk.lay[0].line)
    // selectBid(binmkt.marketName, this.state.market.runners[0].lay[0].price, binmkt.marketId, "lay", this.state.market.runners[0], this.state.market.runners[0].lay[0].line)
    selectBid(runner_name, bid_at, market_id, bid_for, team, bid_line) {
        localStorage.setItem("betForm", JSON.stringify({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.selectionId.toString(), bid_line: bid_line }))
        this.setState({ runner_name: runner_name, bid_at: bid_at, bid_amount: 0, selectionId: team.selectionId.toString(), bid_line: bid_line, bid_for: bid_for }, () => {
            this.props.betForm(this.props.event.markets.filter((itm) => itm.marketType === "DAILY")[0], bid_for, "clicked")
        })
    }
    render() {
        let event = this.props.event
        let is_active = !!this.state.market && this.state.market.status === "OPEN"
        let binmkt = event.markets.filter((itm) => itm.marketType === "DAILY")[0]
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return <>
            <tr>
                <td className="eventInfo">
                    <div onClick={() => { this.props.history.push("/binary"); }} className="event-title" style={{ marginLeft: "5px" }}>
                        <span className="lvnow"></span>{(!!binmkt && binmkt.displayMarketNameTime && binmkt.displayMarketNameTime.length > 0 ? binmkt.displayMarketNameTime[0] : event["name"])} {!!binmkt && binmkt.displayMarketNameTime && binmkt.displayMarketNameTime.length > 0 && <span>[Time: <b>{binmkt.displayMarketNameTime[1]}</b>]</span>}
                        {/* <span className="livenow ml-2">Live Now</span> */}
                    </div>
                    <div className="livenow ml-2 livenownew">Live Now</div>
                    {/* <div className="d-inline float-right">
                        {!!this.state.market && !!this.state.market.evtMeta && !!this.state.market.evtMeta.hasTv && this.state.market.evtMeta.hasTv === 'true' && <span className="l-tv">
                            <img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/tv.svg"} />
                        </span>}
                        {!!this.state.market && !!this.state.market.evtMeta && !!this.state.market.evtMeta.hasSpecial && this.state.market.evtMeta.hasSpecial === 'true' && <span className="p-fancy"></span>}
                        {!!this.state.market && !!this.state.market.evtMeta && !!this.state.market.evtMeta.hasBookMaker && this.state.market.evtMeta.hasBookMaker === 'true' && <span className="bm1"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/bm-icon1.svg"} /></span>}
                        {!!this.state.market && !!this.state.market.evtMeta && !!this.state.market.evtMeta.hasSession && this.state.market.evtMeta.hasSession === 'true' && <span className="fancy1 mr-1"><img alt="" src={BASE_IMAGE_PATH + "/" + oid + "/uimg/fancy-icon1.svg"} /></span>}
                    </div> */}
                </td>
                <td className="col-home">
                </td>
                {/* <td className="col-draw">
                </td> */}
                <td className="col-visit" colSpan={2}>
                    <div className={this.state.market.status === "OPEN" ? "" : "suspended-full"} >
                        <a id="btnLay" className="btn-lay " side="Lay" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners[0].lay[0].price > 0 && this.selectBid(binmkt.marketName, this.state.market.runners[0].lay[0].price, binmkt.marketId, "lay", this.state.market.runners[0], this.state.market.runners[0].lay[0].line) }} style={!!this.state.market && !!this.state.market.runners && this.state.market.runners[0].lay[0] && this.state.market.runners[0].lay[0].has_blink ? { background: "gold" } : null}>
                            <div style={{ minHeight: "13px" }}>{!!this.state.market && !!this.state.market.runners && this.state.market.runners[0].lay[0] && is_active ? this.state.market.runners[0].lay[0].line : ""}</div>
                        </a>
                        <a id="btnBack" className="btn-back " side="Back" onClick={() => { !!this.state.market && this.state.market !== null && !!this.state.market.runners && this.state.market.runners[0].back[0].price > 0 && this.selectBid(binmkt.marketName, this.state.market.runners[0].back[0].price, binmkt.marketId, "back", this.state.market.runners[0], this.state.market.runners[0].back[0].line) }} style={!!this.state.market && !!this.state.market.runners && this.state.market.runners[0].back[0] && this.state.market.runners[0].back[0].has_blink ? { background: "gold" } : null}>
                            <div style={{ minHeight: "13px" }}>{!!this.state.market && !!this.state.market.runners && this.state.market.runners[0].back[0] && is_active ? this.state.market.runners[0].back[0].line : ""}</div>
                        </a>
                    </div>
                </td>
                <td className="col-info">
                    {(!!accData && Object.keys(accData).length > 0) && <a onClick={(e) => { e.stopPropagation(); this.props.toggleMultiMarket(this.state.market.marketId); }} className={this.props.pinnedEvents.indexOf(this.state.market.marketId) > -1 ? "add-pin-d select-pin-d" : "add-pin-d select-pind"} style={{ "cursor": "pointer" }} title="Add to Multi Markets"></a>}
                </td>
            </tr>
            {/* <BetForm loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} gameCode={"300"} eventMarket={binmkt} market={this.state.market} selcted_bet_option={this.state.bid_for} addBet={(data) => { data.event_name = event["name"]; data.marketId = this.state.marketId; data.selectionId = this.state.selectionId; this.props.addBet(data); }} runner_name={this.state.runner_name} bid_at={this.state.bid_at} bid_line={this.state.bid_line} betForm={(game, event) => { this.props.betForm(game, event) }} /> updateExpo={(expo) => { this.updateExpo(expo) }}*/}
            {this.props.selected_game_code === this.props.gameCode && this.props.selected_event_code === event.id &&
                <BetForm key={`betform_${binmkt.marketId}`} loadingBet={this.props.loadingBet} notify={(msg, type) => { this.props.notify(msg, type) }} eventMarket={binmkt} gameCode={"300"} selcted_bet_option={this.state.bid_for} selectionId={this.state.selectionId} runner_name={this.state.runner_name} bid_at={this.state.bid_at} bid_line={this.state.bid_line} betForm={this.props.betForm} addBet={(data) => { data.marketId = binmkt.marketId; data.selectionId = this.state.selectionId; this.props.addBet(data) }} />
            }
        </>
    }
}
